export default __webpack_public_path__ + "static/media/file-safety-filled.1b08fa19.svg";